<!--
 * @Description:
 * @Version: 2.0
 * @Autor: daikeyi
 * @Date: 2020-06-05 15:25:04
 * @LastEditors: daikeyi
 * @LastEditTime: 2021-01-20 11:25:23
-->
<template>
    <div class="menu-panel">
        <ul class="menu-panel-container">
            <li class="menu-panel-item" v-for="item in menus" :style="{width: itemW}" @click="itemClicked(item)" :key="item.id">
                <img class="menu-icon" :src="item.commont" :style="{width: menuIconSize,height :menuIconSize}" />
                <div class="menu-title">{{item.adName}}</div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {

        };
    },
    props: {
        menus: {
            default: () => {
                return [];
            }
        },
        column: {
            default: () => {
                return 4;
            }
        },
        menuIconSize: {
            default: () => {
                return '40px';
            }
        }
    },
    computed: {
        itemW() { // 获取宽度
            return 100 / this.column + '%';
        }
    },
    methods: {
        itemClicked(item) { // 菜单被点击
            this.$emit('itemClicked', item);
        }
    }
};
</script>
<style scoped>
    .menu-panel {
        background: white;
    }

    .menu-title {
        font-size: 12px;
        padding: 5px 5px 0px 5px;
    }

    .menu-panel-item {
        display: inline-block;
        text-align: center;
        padding: 10px 0px;
        box-sizing: border-box;
    }

</style>
